export async function fetchDealer(dealerId: string): Promise<any | null> {
    const response = await fetch(`api/webchat/dealer/${dealerId}`);
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response.json();
}